import { GzHealthDashboardInsights } from './GzHealthDashboardInsights';
import { WEB_COMPONENT_HEALTH_DASHBOARD_SIGNATURE_UPDATE } from '../../../../webcomponents.constants';
import { HealthDashboardSignatureUpdateStrings, InsightsTemplatesStringKeys } from '../types';
import { translateFn } from '../../../../utils/translator.helper';
import { WidgetSectionItemSeverity } from '../../../../ui/gzWidgetSectionItem/types';
import { customElement } from 'lit/decorators.js';

@customElement(WEB_COMPONENT_HEALTH_DASHBOARD_SIGNATURE_UPDATE)
export class GzHealthDashboardSignatureUpdateStatusWebComponent extends GzHealthDashboardInsights {
  protected widgetKey = InsightsTemplatesStringKeys.SIGNATURE_UPDATE_STATUS;

  protected strings: HealthDashboardSignatureUpdateStrings = {
    sections: [
      {
        key: InsightsTemplatesStringKeys.SIGNATURE_INFO,
        items: [
          {
            key: InsightsTemplatesStringKeys.UPDATED,
            name: translateFn('Updated'),
            tooltipText: translateFn('Endpoints are up to date, and no new updates are currently available.'),
            severity: WidgetSectionItemSeverity.SUCCESS,
          },
          {
            key: InsightsTemplatesStringKeys.OFFLINE_MORE_THAN_ONE_DAY,
            name: translateFn('Offline more than 24 hours'),
            tooltipText: translateFn('Endpoints were offline for more than 24 hours.'),
            severity: WidgetSectionItemSeverity.WARNING,
          },
          {
            key: InsightsTemplatesStringKeys.UPDATE_DISABLED,
            name: translateFn('Update disabled'),
            tooltipText: translateFn('Security content update is disabled from the policy applied on endpoints.'),
            severity: WidgetSectionItemSeverity.WARNING,
          },
          {
            key: InsightsTemplatesStringKeys.OUTDATED,
            name: translateFn('Outdated'),
            tooltipText: translateFn('Endpoints were online within the past 24 hours but could not receive updates.'),
            severity: WidgetSectionItemSeverity.ERROR,
          },
        ],
      },
    ],
  };
}
